import { forwardRef } from 'react';
import type { InputHTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

export const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  ({ className, type = 'text', ...props }, ref) => (
    <input
      ref={ref}
      type={type}
      className={cn(
        'h-11 w-full rounded-inset border-2 border-hairline-strong bg-surface px-3.5 text-sm text-ink',
        'placeholder:text-ink-faint',
        'transition-[border-color,box-shadow] duration-150',
        'focus-visible:border-ink focus-visible:outline-none',
        'disabled:cursor-not-allowed disabled:opacity-50',
        'aria-[invalid=true]:border-critical',
        className,
      )}
      {...props}
    />
  ),
);
Input.displayName = 'Input';
